module.exports = __webpack_public_path__ + "media/src/images/app_icons/favicons/android-icon-192x192-26bffbb6097ac6693177e2a208ccd789.png";